import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import { getShifts } from 'api/shifts'
import { Company, WorkShift } from 'api/typings'
import { filterShiftsLocally, getRowStyles } from '../utils/util'
import { getShiftColumns } from './shifts'
import { getCompanies } from 'api/company'
import ShiftsFilterBar2 from '../Shared/ShiftsFilterBar2'
import Loading from '../Shared/loading'
import { useSearchParams } from 'react-router-dom' // Corrected import
import { Box, Button, Heading } from '@workwhile/ui'

const OngoingShifts = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [filters, setFilters] = useState({
    companyIds: searchParams.get('companyIds')?.split(',').map(Number) ?? [],
    shiftId: searchParams.get('shiftId')
      ? Number(searchParams.get('shiftId'))
      : null,
    fromDate: searchParams.get('fromDate')
      ? searchParams.get('fromDate')
      : null,
    toDate: searchParams.get('toDate') ? searchParams.get('toDate') : null,
    market: searchParams.get('market'),
    showUnfilledShiftsOnly: false,
    showCancelledShiftsOnly: false,
  })

  const [fetching, setFetching] = useState(false)
  const [fetchingFilters, setFetchingFilters] = useState(false)
  const [shifts, setShifts] = useState<WorkShift[]>([])
  const columns = getShiftColumns('ongoing', null)
  const [needToFetchOnFirstLoad, setNeedToFetchOnFirstLoad] = useState(
    Array.from(searchParams).length > 0
  )
  const [companyOptions, setCompanyOptions] = useState<Company[]>([])

  useEffect(() => {
    setFetchingFilters(true)
    getCompanies({ grouping: 'ongoing' })
      .then((companies) => {
        setCompanyOptions(companies)
      })
      .finally(() => setFetchingFilters(false))
  }, [])

  useEffect(() => {
    const params = new URLSearchParams()
    if (filters.companyIds.length > 0) {
      params.set('companyIds', filters.companyIds.join(','))
    }
    if (filters.shiftId) {
      params.set('shiftId', String(filters.shiftId))
    }
    if (filters.market) {
      params.set('market', String(filters.market))
    }
    if (filters.fromDate) {
      params.set('fromDate', filters.fromDate)
    }
    if (filters.toDate) {
      params.set('toDate', filters.toDate)
    }
    setSearchParams(params) // Use setSearchParams to update the URL
    if (needToFetchOnFirstLoad) {
      fetchShifts()
      setNeedToFetchOnFirstLoad(false)
    }
  }, [filters])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target
    setFilters((prevState) => ({
      ...prevState,
      [name]: checked,
    }))
  }

  const fetchShifts = () => {
    setFetching(true)
    getShifts({
      type: 'ongoing',
      companyIds: filters.companyIds,
      shiftId: filters.shiftId ?? undefined,
      market: filters.market ?? undefined,
      isUnfilled: filters.showUnfilledShiftsOnly,
    })
      .then((shiftsData) => {
        setShifts(shiftsData)
      })
      .finally(() => setFetching(false))
  }

  return (
    <Box>
      <Box
        as="form"
        mb={4}
        onSubmit={(e) => {
          e.preventDefault()
          fetchShifts()
        }}
      >
        <Heading level={3}>
          Ongoing shifts ({'start - 30mins < current time < end + 30mins'})
        </Heading>
        {Boolean(fetchingFilters) && <Loading />}
        {!fetchingFilters && (
          <ShiftsFilterBar2
            {...(filters as any)}
            companyOptions={companyOptions}
            handleInputChange={handleInputChange}
            handleCheckboxChange={handleCheckboxChange}
          />
        )}
        <Button type="submit" disabled={fetching}>
          Load shifts
        </Button>
        {Boolean(fetching) && <Loading />}
      </Box>
      {Boolean(shifts && shifts.length > 0 && !fetching) && (
        <BootstrapTable
          striped
          hover
          keyField="id"
          data={filterShiftsLocally(
            shifts,
            filters.showCancelledShiftsOnly,
            filters.showUnfilledShiftsOnly
          )}
          columns={columns}
          rowStyle={getRowStyles}
        />
      )}
    </Box>
  )
}

export default OngoingShifts
